import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { MusicIcon, SproutIcon, TimerIcon } from 'lucide-react';
import { Plant } from '../components/Plant';
const POINTS: {
  Icon: typeof TimerIcon;
  text: string;
}[] = [{
  Icon: TimerIcon,
  text: 'Sessions from 1 to 180 minutes'
}, {
  Icon: SproutIcon,
  text: 'A plant that grows with your focus'
}, {
  Icon: MusicIcon,
  text: 'Optional rain, forest, or ocean'
}];
export function Landing({
  onStart
}: {
  onStart: () => void;
}) {
  const reduceMotion = useReducedMotion();
  return <main className="mx-auto flex min-h-screen w-full max-w-md flex-col px-5 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-[max(1.5rem,env(safe-area-inset-top))]" data-id="element-87" data-mp="3f9f8kl3bo0x">
      <p className="text-sm font-semibold tracking-tight text-ink" data-id="element-88" data-mp="c8cn8dcyv8o6">Focus</p>

      <motion.div initial={reduceMotion ? false : {
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="flex flex-1 flex-col items-center justify-center text-center" data-id="element-89" data-mp="h8qu3s2u0ckm">
        <Plant progress={1} running={false} growthKey={0} data-id="element-90" data-mp="27nvfarb7dl8" />

        <h1 className="mt-6 max-w-[16ch] text-3xl font-semibold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-91" data-mp="3tfjy1gh1wxjx">
          A calm pomodoro timer
        </h1>
        <p className="mt-3 max-w-[30ch] text-sm leading-relaxed text-muted" data-id="element-92" data-mp="3kfwvusghznpt">
          Pick a session, start it, and let the plant grow alongside your attention. Nothing else.
        </p>

        <ul className="mt-8 flex w-full max-w-[19rem] flex-col gap-3 text-left" data-id="element-93" data-mp="gywu09d6w9ai">
          {POINTS.map(({
          Icon,
          text
        }) => <li key={text} className="flex items-center gap-3 text-sm text-ink" data-id="element-94" data-mp="c7ep5a81pok9">
              <Icon size={18} strokeWidth={1.5} className="shrink-0 text-muted" aria-hidden="true" data-id="element-95" data-mp="79myskn1uai6" />
              {text}
            </li>)}
        </ul>
      </motion.div>

      <div className="mt-10" data-id="element-96" data-mp="zxsjj7e3rzi0">
        <button type="button" onClick={onStart} className="min-h-[56px] w-full rounded-2xl bg-coral text-base font-semibold text-white transition-colors duration-150 hover:bg-coral-strong focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral" data-id="element-97" data-mp="zxir7d5l5g95">
          Start focusing
        </button>
        <p className="mt-3 text-center text-xs text-muted" data-id="element-98" data-mp="1e32nau50yvep">
          No account. Everything stays on this device.
        </p>
      </div>
    </main>;
}